export default "__VITE_ASSET__bWMJD$or__"